module.exports = __webpack_public_path__ + "img/74.5b6467f4.svg";